module.exports = __webpack_public_path__ + "static/img/Cam-Rayner.ed995a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cam-Rayner.jpg
// module id = mRh2
// module chunks = 0